import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import { CreateMascConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';

export class CreateMascNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: CreateMascConfig) {
    super(id, NodeType.CreateMasc, position, config);
  }

  isEmptyConfig(): boolean {
    return false;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig(): void {}

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    return errors;
  }
}
